(function () {
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('animate-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  function observeAll(root) {
    const elements = root.querySelectorAll('[data-animate]');
    elements.forEach((el) => observer.observe(el));
    return elements.length;
  }

  // Watch for elements added by infinite scroll
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.hasAttribute('data-animate')) {
          observer.observe(node);
        } else {
          observeAll(node);
        }
      });
    });
  });

  function init() {
    if (observeAll(document) === 0) return;
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
